// Shared option lists used across the intake routes.

export const FUNDING_OPTIONS = [
  "I do not presently have funding available.",
  "Up to £1,000",
  "£1,000 to £3,000",
  "£3,000 to £5,000",
  "More than £5,000",
];

export const MIAM_OPTIONS = [
  { value: "attended", label: "Yes, I attended." },
  { value: "arranged", label: "It has been arranged but has not taken place." },
  { value: "ongoing", label: "Mediation is ongoing." },
  { value: "declined", label: "The other person did not attend or declined." },
  { value: "unsuitable", label: "The mediator decided mediation was unsuitable." },
  { value: "no", label: "No." },
  { value: "unsure", label: "I am not sure what a MIAM is." },
];

// Selections that require MIAM follow-up detail
export const MIAM_DETAIL_TRIGGERS = ["attended", "ongoing", "declined", "unsuitable"];

export const MATTER_CATEGORIES = [
  "Arrangements for children (child arrangements)",
  "Parental responsibility",
  "Relocation or removal of a child",
  "Financial matters on divorce or separation",
  "Divorce or dissolution",
  "Domestic abuse or protective orders",
  "Enforcement of an existing order",
  "Public law / local authority involvement",
  "Other — please state",
];

export const HEARING_TYPES = [
  "First hearing",
  "Directions or case-management hearing",
  "Dispute resolution hearing",
  "Fact-finding hearing",
  "FDA",
  "FDR",
  "Final hearing",
  "Enforcement hearing",
  "Appeal or permission-to-appeal hearing",
  "Other — please state",
  "I do not know",
];

export const CASE_HELP_OPTIONS = [
  "Strategic/Procedural guidance",
  "Help preparing an application or response",
  "Help preparing a statement",
  "Review of evidence or documents",
  "Help preparing for a hearing",
  "Strategic guidance for negotiations or mediation",
  "Guidance relevant to complying with or enforcing an order",
  "Ongoing case-management assistance",
  "Help preparing financial or assessing financial disclosure",
  "Help preparing a court bundle",
  "Other — please state",
  "I am not sure",
];

export const MAX_UPLOAD_HINT = (mb) =>
  `Accepted formats: PDF, Word document, JPEG, PNG. Maximum size ${mb} MB.`;
